import { Suspense, useState, useEffect } from "react";
import "../i18n";
import { ArrowUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
import Services from "../components/Services/Services";
import Expertises from "../components/Expertises/Expertises";
import Stats from "../components/Stats/Stats";
import Projects from "../components/Projects/Projects";
import References from "../components/References/References";
import Contact from "../components/Contact/Contact";
import Footer from "../components/Footer/Footer";
import ReasonToChooseUs from "../components/ReasonToChooseUs/ReasonToChooseUs";

const Public = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScrollButton(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <Suspense fallback="Loading...">
      <div className="min-h-screen flex flex-col bg-auxis-off-white dark:bg-auxis-charcoal transition-colors duration-300">
        <Navbar />
        <main className="flex-1">
          <Hero />
          <Services />
          <Stats />
          <Projects />
          <Expertises />
          <ReasonToChooseUs />
          <References />
          <Contact />
        </main>
        <Footer />

        {/* Scroll to top */}
        <AnimatePresence>
          {showScrollButton && (
            <motion.button
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={scrollToTop}
              className="fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full bg-auxis-charcoal dark:bg-auxis-gold text-white dark:text-auxis-charcoal shadow-soft-lg hover:shadow-soft-xl flex items-center justify-center transition-shadow duration-300"
              aria-label="Retour en haut"
            >
              <ArrowUp size={18} />
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </Suspense>
  );
};

export default Public;
